import React from "react";

import { twMerge } from "tailwind-merge";

import Modal from "components/Modal";
import SmartscriptRequestLoader from "components/Smartscript/SmartscriptRequestLoader";

const SmartscriptModal = ({
  isOpen,
  onClose,
  transcriptId,
  loading,
}: {
  isOpen: boolean;
  onClose: () => void;
  transcriptId?: string | number;
  loading?: boolean;
}) => {
  if (!loading && !transcriptId) return null;

  return (
    <Modal
      isOpen={isOpen}
      shouldCloseOnEsc
      onClose={onClose}
      className={twMerge("lg:w-[720px] xl:w-[920px] md:!my-[40px]")}
      overlayClassName=""
      onAfterOpen={() =>
        document.body.classList.add("!max-h-[calc(100vh-100px)]")
      }
      onAfterClose={() =>
        document.body.classList.remove("!max-h-[calc(100vh-100px)]")
      }
      fullMobilePage
      closeCTAClassName="top-[7px] right-[20px]"
    >
      {loading || !transcriptId ? (
        <SmartscriptRequestLoader />
      ) : (
        <iframe
          title="Smartscript"
          src={`https://smartscripts.smartkarma.com/embed/t/${transcriptId}`}
          className="w-full h-[calc(100vh-100px)] rounded-xl border-0"
          allow="clipboard-write"
        />
      )}
    </Modal>
  );
};

export default SmartscriptModal;
